import { motion } from "framer-motion";
import { PackageOpen, ArrowRight } from "lucide-react";

export const SubscriptionTeaser = () => (
  <section data-testid="subscription-teaser" className="py-10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.a
        href="/abonnementen"
        data-testid="subscription-teaser-link"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="group relative block overflow-hidden rounded-3xl border border-[#FF087B]/40 bg-gradient-to-r from-[#1a0a14] via-[#0D1320] to-[#041a12] p-10 sm:p-14"
      >
        <div className="absolute -right-16 -top-16 w-64 h-64 rounded-full bg-[#FF087B]/15 blur-[80px] pointer-events-none" />
        <div className="absolute -left-10 -bottom-16 w-64 h-64 rounded-full bg-[#00FF66]/10 blur-[80px] pointer-events-none" />
        <div className="relative flex flex-col md:flex-row md:items-center gap-8 justify-between">
          <div className="flex items-start gap-5">
            <div className="hidden sm:flex w-16 h-16 rounded-2xl bg-[#FF087B]/15 border border-[#FF087B]/40 items-center justify-center shrink-0">
              <PackageOpen className="w-8 h-8 text-[#FF087B]" />
            </div>
            <div>
              <p className="font-mono-brand text-xs uppercase tracking-widest text-[#FF087B] mb-2">Nieuw — Gelvaro Club</p>
              <h2 className="font-display text-4xl sm:text-5xl uppercase tracking-wide text-white leading-none">
                Elke maand verse orbs<br className="hidden sm:block" /> of een <span className="text-gradient-splat">mystery pack</span>
              </h2>
              <p className="mt-3 text-sm text-slate-400 max-w-lg">
                Word lid van de Gelvaro Club: maandelijks 20.000 orbs, verrassende gear en exclusieve ledendrops. Vanaf €9,95 per maand.
              </p>
            </div>
          </div>
          <span className="inline-flex items-center gap-2 bg-gradient-to-r from-[#FF087B] to-[#00E5FF] text-white font-extrabold uppercase tracking-wider px-7 py-4 rounded-full shrink-0 group-hover:scale-105 transition-transform">
            Word lid <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </motion.a>
    </div>
  </section>
);
